import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import ApiService from "./service/http.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import "./assets/css/iconfont.css";
import * as echarts from "echarts/core";
import "./directives";
import VueClipboard from 'vue-clipboard2'
import draggable from './draggable'
import { TitleComponent, TooltipComponent } from "echarts/components";
import { GraphChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

import Ellipsis from './components/common/Ellipsis'
import WDialog from './components/common/WDialog'
import Tip from './components/common/Tip'

echarts.use([TitleComponent, TooltipComponent, GraphChart, CanvasRenderer]);

Vue.prototype.echarts = echarts;
Vue.use(VueClipboard)
Vue.use(ElementUI, { size: "small", zIndex: 10001 });
Vue.use(draggable)
Vue.use(Ellipsis);
Vue.use(WDialog);
Vue.use(Tip);


Vue.prototype.$isNotEmpty = function(obj){
  return (obj !== undefined && obj !== null && obj !== '' && obj !== 'null')
}

Vue.prototype.$getDefalut = function(obj, key, df){
  return (obj === undefined || key === undefined || !this.$isNotEmpty(obj[key])) ? df : obj[key];
}

Vue.prototype.$deepCopy = function (obj){return JSON.parse(JSON.stringify(obj))}



Vue.config.productionTip = false
Vue.prototype.http = new ApiService();
/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
